import Vue from "vue";

import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import '../assets/scss/main.scss';

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
